import { createSlice } from "@reduxjs/toolkit";

export const loaderSlice = createSlice({
    name: 'loader',
    initialState: {
        showLoader: false,
        loaderCount: 0
    },
    reducers: {
        showLoader: (state) => {
            state.loaderCount++;
            state.showLoader = true;
        },
        hideLoader: (state) => {
            state.loaderCount--;
            if (state.loaderCount <= 0) {
                state.showLoader = false;
                state.loaderCount = 0;
            }
        }
    }
});

export const { showLoader, hideLoader } = loaderSlice.actions;

export default loaderSlice.reducer;